export type MindsetCompanyPlanKey = "LITE" | "PAID";

export const MINDSET_INDIVIDUAL_PRICE = {
  label: "Individual",
  displayPrice: "Free",
  detail: "Personal Mindset handles, messages, voice calls, and video calls stay free for individuals.",
} as const;

export const MINDSET_BUSINESS_IDENTITY_PRICE = {
  label: "Business @ identity",
  displayPrice: "$12/year per business @",
  unitAmountCents: 1_200,
  currency: "USD",
  interval: "year",
  unitLabel: "business @",
} as const;

export const MINDSET_BUSINESS_WORKSPACE_PRICE = {
  label: "Business communications workspace",
  displayPrice: "$36/year flat per company",
  unitAmountCents: 3_600,
  currency: "USD",
  interval: "year",
  unitLabel: "workspace",
  flatRate: true,
} as const;

export const MINDSET_BUSINESS_PRICE_SUMMARY =
  `${MINDSET_BUSINESS_IDENTITY_PRICE.displayPrice} + ${MINDSET_BUSINESS_WORKSPACE_PRICE.displayPrice}`;

export function formatBusinessIdentityAnnualTotal(handleCount: number) {
  const safeHandleCount = Number.isFinite(handleCount) && handleCount > 0 ? Math.floor(handleCount) : 0;
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: MINDSET_BUSINESS_IDENTITY_PRICE.currency,
    maximumFractionDigits: 0,
  }).format(safeHandleCount * MINDSET_BUSINESS_IDENTITY_PRICE.unitAmountCents / 100);
}

export function formatCompanyPlan(plan: MindsetCompanyPlanKey) {
  return plan === "PAID" ? "Business Identity" : "Workspace review";
}

export function formatCompanyPlanPrice(plan: MindsetCompanyPlanKey) {
  return plan === "PAID" ? MINDSET_BUSINESS_PRICE_SUMMARY : "Free trial workspace";
}
